/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { BatchUpdateResponse } from '../models/batch-update-response';
import { customerOrderStatusControllerCreate } from '../fn/order/customer-order-status-controller-create';
import { CustomerOrderStatusControllerCreate$Params } from '../fn/order/customer-order-status-controller-create';
import { customerOrderStatusControllerFindAll } from '../fn/order/customer-order-status-controller-find-all';
import { CustomerOrderStatusControllerFindAll$Params } from '../fn/order/customer-order-status-controller-find-all';
import { customerOrderStatusControllerFindOne } from '../fn/order/customer-order-status-controller-find-one';
import { CustomerOrderStatusControllerFindOne$Params } from '../fn/order/customer-order-status-controller-find-one';
import { customerOrderStatusControllerGetAll } from '../fn/order/customer-order-status-controller-get-all';
import { CustomerOrderStatusControllerGetAll$Params } from '../fn/order/customer-order-status-controller-get-all';
import { customerOrderStatusControllerRemove } from '../fn/order/customer-order-status-controller-remove';
import { CustomerOrderStatusControllerRemove$Params } from '../fn/order/customer-order-status-controller-remove';
import { customerOrderStatusControllerUpdate } from '../fn/order/customer-order-status-controller-update';
import { CustomerOrderStatusControllerUpdate$Params } from '../fn/order/customer-order-status-controller-update';
import { EmptyResponse } from '../models/empty-response';
import { NextStatesResponse } from '../models/next-states-response';
import { orderControllerCanEdit } from '../fn/order/order-controller-can-edit';
import { OrderControllerCanEdit$Params } from '../fn/order/order-controller-can-edit';
import { orderControllerChangeOrderWorkflowStatus } from '../fn/order/order-controller-change-order-workflow-status';
import { OrderControllerChangeOrderWorkflowStatus$Params } from '../fn/order/order-controller-change-order-workflow-status';
import { orderControllerCreate } from '../fn/order/order-controller-create';
import { OrderControllerCreate$Params } from '../fn/order/order-controller-create';
import { orderControllerDeleteOne } from '../fn/order/order-controller-delete-one';
import { OrderControllerDeleteOne$Params } from '../fn/order/order-controller-delete-one';
import { orderControllerEdit } from '../fn/order/order-controller-edit';
import { OrderControllerEdit$Params } from '../fn/order/order-controller-edit';
import { orderControllerFindOrderNodes } from '../fn/order/order-controller-find-order-nodes';
import { OrderControllerFindOrderNodes$Params } from '../fn/order/order-controller-find-order-nodes';
import { orderControllerGetAll } from '../fn/order/order-controller-get-all';
import { OrderControllerGetAll$Params } from '../fn/order/order-controller-get-all';
import { orderControllerGetOne } from '../fn/order/order-controller-get-one';
import { OrderControllerGetOne$Params } from '../fn/order/order-controller-get-one';
import { orderCustomerControllerBatchChangeCustomerOrderStatus } from '../fn/order/order-customer-controller-batch-change-customer-order-status';
import { OrderCustomerControllerBatchChangeCustomerOrderStatus$Params } from '../fn/order/order-customer-controller-batch-change-customer-order-status';
import { orderCustomerControllerChangeCustomerOrderWorkflowStatus } from '../fn/order/order-customer-controller-change-customer-order-workflow-status';
import { OrderCustomerControllerChangeCustomerOrderWorkflowStatus$Params } from '../fn/order/order-customer-controller-change-customer-order-workflow-status';
import { orderCustomerControllerCreate } from '../fn/order/order-customer-controller-create';
import { OrderCustomerControllerCreate$Params } from '../fn/order/order-customer-controller-create';
import { orderCustomerControllerDeleteOne } from '../fn/order/order-customer-controller-delete-one';
import { OrderCustomerControllerDeleteOne$Params } from '../fn/order/order-customer-controller-delete-one';
import { orderCustomerControllerEdit } from '../fn/order/order-customer-controller-edit';
import { OrderCustomerControllerEdit$Params } from '../fn/order/order-customer-controller-edit';
import { orderCustomerControllerFindOrderCustomerNodes } from '../fn/order/order-customer-controller-find-order-customer-nodes';
import { OrderCustomerControllerFindOrderCustomerNodes$Params } from '../fn/order/order-customer-controller-find-order-customer-nodes';
import { orderCustomerControllerGetAll } from '../fn/order/order-customer-controller-get-all';
import { OrderCustomerControllerGetAll$Params } from '../fn/order/order-customer-controller-get-all';
import { orderCustomerControllerGetOne } from '../fn/order/order-customer-controller-get-one';
import { OrderCustomerControllerGetOne$Params } from '../fn/order/order-customer-controller-get-one';
import { orderCustomerControllerGetReplaceProductImpact } from '../fn/order/order-customer-controller-get-replace-product-impact';
import { OrderCustomerControllerGetReplaceProductImpact$Params } from '../fn/order/order-customer-controller-get-replace-product-impact';
import { orderCustomerControllerPreviewEmailBody } from '../fn/order/order-customer-controller-preview-email-body';
import { OrderCustomerControllerPreviewEmailBody$Params } from '../fn/order/order-customer-controller-preview-email-body';
import { orderCustomerControllerReplaceProduct } from '../fn/order/order-customer-controller-replace-product';
import { OrderCustomerControllerReplaceProduct$Params } from '../fn/order/order-customer-controller-replace-product';
import { orderCustomerControllerSendEmail } from '../fn/order/order-customer-controller-send-email';
import { OrderCustomerControllerSendEmail$Params } from '../fn/order/order-customer-controller-send-email';
import { OrderCustomerItem } from '../models/order-customer-item';
import { OrderCustomerItemEssential } from '../models/order-customer-item-essential';
import { OrderCustomerListResponse } from '../models/order-customer-list-response';
import { OrderItem } from '../models/order-item';
import { OrderItemDetail } from '../models/order-item-detail';
import { OrderListResponse } from '../models/order-list-response';
import { orderStatusControllerCreate } from '../fn/order/order-status-controller-create';
import { OrderStatusControllerCreate$Params } from '../fn/order/order-status-controller-create';
import { orderStatusControllerFindAll } from '../fn/order/order-status-controller-find-all';
import { OrderStatusControllerFindAll$Params } from '../fn/order/order-status-controller-find-all';
import { orderStatusControllerFindOne } from '../fn/order/order-status-controller-find-one';
import { OrderStatusControllerFindOne$Params } from '../fn/order/order-status-controller-find-one';
import { orderStatusControllerGetAll } from '../fn/order/order-status-controller-get-all';
import { OrderStatusControllerGetAll$Params } from '../fn/order/order-status-controller-get-all';
import { orderStatusControllerRemove } from '../fn/order/order-status-controller-remove';
import { OrderStatusControllerRemove$Params } from '../fn/order/order-status-controller-remove';
import { orderStatusControllerUpdate } from '../fn/order/order-status-controller-update';
import { OrderStatusControllerUpdate$Params } from '../fn/order/order-status-controller-update';
import { OrderStatusItem } from '../models/order-status-item';
import { OrderStatusListResponse } from '../models/order-status-list-response';
import { OrderStatusPaginatedResponseItem } from '../models/order-status-paginated-response-item';
import { StringItem } from '../models/string-item';

@Injectable({ providedIn: 'root' })
export class OrderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `orderStatusControllerGetAll()` */
  static readonly OrderStatusControllerGetAllPath = '/order/status';

  /**
   * Restituisce l'elenco degli stati degli ordini.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderStatusControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderStatusControllerGetAll$Response(params?: OrderStatusControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusListResponse;
}>> {
    return orderStatusControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli stati degli ordini.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderStatusControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderStatusControllerGetAll(params?: OrderStatusControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderStatusListResponse;
}> {
    return this.orderStatusControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusListResponse;
}>): BaseResponse & {
'data'?: OrderStatusListResponse;
} => r.body)
    );
  }

  /** Path part for operation `orderStatusControllerCreate()` */
  static readonly OrderStatusControllerCreatePath = '/order/status';

  /**
   * Create a new order status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderStatusControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderStatusControllerCreate$Response(params: OrderStatusControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>> {
    return orderStatusControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new order status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderStatusControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderStatusControllerCreate(params: OrderStatusControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderStatusItem;
}> {
    return this.orderStatusControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>): BaseResponse & {
'data'?: OrderStatusItem;
} => r.body)
    );
  }

  /** Path part for operation `orderStatusControllerFindAll()` */
  static readonly OrderStatusControllerFindAllPath = '/order/status/all';

  /**
   * Get all order statuses with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderStatusControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderStatusControllerFindAll$Response(params?: OrderStatusControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusPaginatedResponseItem;
}>> {
    return orderStatusControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all order statuses with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderStatusControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderStatusControllerFindAll(params?: OrderStatusControllerFindAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderStatusPaginatedResponseItem;
}> {
    return this.orderStatusControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusPaginatedResponseItem;
}>): BaseResponse & {
'data'?: OrderStatusPaginatedResponseItem;
} => r.body)
    );
  }

  /** Path part for operation `orderStatusControllerFindOne()` */
  static readonly OrderStatusControllerFindOnePath = '/order/status/{id}';

  /**
   * Get a order status by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderStatusControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderStatusControllerFindOne$Response(params: OrderStatusControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>> {
    return orderStatusControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a order status by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderStatusControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderStatusControllerFindOne(params: OrderStatusControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderStatusItem;
}> {
    return this.orderStatusControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>): BaseResponse & {
'data'?: OrderStatusItem;
} => r.body)
    );
  }

  /** Path part for operation `orderStatusControllerUpdate()` */
  static readonly OrderStatusControllerUpdatePath = '/order/status/{id}';

  /**
   * Update a order status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderStatusControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderStatusControllerUpdate$Response(params: OrderStatusControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>> {
    return orderStatusControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a order status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderStatusControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderStatusControllerUpdate(params: OrderStatusControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderStatusItem;
}> {
    return this.orderStatusControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>): BaseResponse & {
'data'?: OrderStatusItem;
} => r.body)
    );
  }

  /** Path part for operation `orderStatusControllerRemove()` */
  static readonly OrderStatusControllerRemovePath = '/order/status/{id}';

  /**
   * Delete a order status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderStatusControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderStatusControllerRemove$Response(params: OrderStatusControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>> {
    return orderStatusControllerRemove(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a order status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderStatusControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderStatusControllerRemove(params: OrderStatusControllerRemove$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderStatusItem;
}> {
    return this.orderStatusControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>): BaseResponse & {
'data'?: OrderStatusItem;
} => r.body)
    );
  }

  /** Path part for operation `orderControllerGetAll()` */
  static readonly OrderControllerGetAllPath = '/order';

  /**
   * Restituisce l'elenco degli ordini.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerGetAll$Response(params: OrderControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderListResponse;
}>> {
    return orderControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli ordini.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerGetAll(params: OrderControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderListResponse;
}> {
    return this.orderControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderListResponse;
}>): BaseResponse & {
'data'?: OrderListResponse;
} => r.body)
    );
  }

  /** Path part for operation `orderControllerCreate()` */
  static readonly OrderControllerCreatePath = '/order';

  /**
   * Crea un ordine.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerCreate$Response(params: OrderControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderItem;
}>> {
    return orderControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un ordine.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerCreate(params: OrderControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderItem;
}> {
    return this.orderControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderItem;
}>): BaseResponse & {
'data'?: OrderItem;
} => r.body)
    );
  }

  /** Path part for operation `orderControllerFindOrderNodes()` */
  static readonly OrderControllerFindOrderNodesPath = '/order/nodes/{id}';

  /**
   * Restituisce gli stati successivi dell'ordine disponibili in base a quello attuale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerFindOrderNodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerFindOrderNodes$Response(params: OrderControllerFindOrderNodes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: NextStatesResponse;
}>> {
    return orderControllerFindOrderNodes(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce gli stati successivi dell'ordine disponibili in base a quello attuale.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerFindOrderNodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerFindOrderNodes(params: OrderControllerFindOrderNodes$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: NextStatesResponse;
}> {
    return this.orderControllerFindOrderNodes$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: NextStatesResponse;
}>): BaseResponse & {
'data'?: NextStatesResponse;
} => r.body)
    );
  }

  /** Path part for operation `orderControllerChangeOrderWorkflowStatus()` */
  static readonly OrderControllerChangeOrderWorkflowStatusPath = '/order/change-order-status/{id}';

  /**
   * Modifica lo stato di un ordine.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerChangeOrderWorkflowStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerChangeOrderWorkflowStatus$Response(params: OrderControllerChangeOrderWorkflowStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderItemDetail;
}>> {
    return orderControllerChangeOrderWorkflowStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica lo stato di un ordine.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerChangeOrderWorkflowStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerChangeOrderWorkflowStatus(params: OrderControllerChangeOrderWorkflowStatus$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderItemDetail;
}> {
    return this.orderControllerChangeOrderWorkflowStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderItemDetail;
}>): BaseResponse & {
'data'?: OrderItemDetail;
} => r.body)
    );
  }

  /** Path part for operation `orderControllerCanEdit()` */
  static readonly OrderControllerCanEditPath = '/order/{id}/isEditable';

  /**
   * Restituisce 200 se l'ordine è modificabile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerCanEdit()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerCanEdit$Response(params: OrderControllerCanEdit$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return orderControllerCanEdit(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce 200 se l'ordine è modificabile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerCanEdit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerCanEdit(params: OrderControllerCanEdit$Params, context?: HttpContext): Observable<void> {
    return this.orderControllerCanEdit$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `orderControllerGetOne()` */
  static readonly OrderControllerGetOnePath = '/order/{id}';

  /**
   * Restituisce un ordine.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerGetOne$Response(params: OrderControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderItemDetail;
}>> {
    return orderControllerGetOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un ordine.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerGetOne(params: OrderControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderItemDetail;
}> {
    return this.orderControllerGetOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderItemDetail;
}>): BaseResponse & {
'data'?: OrderItemDetail;
} => r.body)
    );
  }

  /** Path part for operation `orderControllerDeleteOne()` */
  static readonly OrderControllerDeleteOnePath = '/order/{id}';

  /**
   * Elimina un ordine.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerDeleteOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerDeleteOne$Response(params: OrderControllerDeleteOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderItemDetail;
}>> {
    return orderControllerDeleteOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un ordine.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerDeleteOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderControllerDeleteOne(params: OrderControllerDeleteOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderItemDetail;
}> {
    return this.orderControllerDeleteOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderItemDetail;
}>): BaseResponse & {
'data'?: OrderItemDetail;
} => r.body)
    );
  }

  /** Path part for operation `orderControllerEdit()` */
  static readonly OrderControllerEditPath = '/order/{id}';

  /**
   * Modifica un ordine.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderControllerEdit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerEdit$Response(params: OrderControllerEdit$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderItemDetail;
}>> {
    return orderControllerEdit(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un ordine.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderControllerEdit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderControllerEdit(params: OrderControllerEdit$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderItemDetail;
}> {
    return this.orderControllerEdit$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderItemDetail;
}>): BaseResponse & {
'data'?: OrderItemDetail;
} => r.body)
    );
  }

  /** Path part for operation `orderCustomerControllerPreviewEmailBody()` */
  static readonly OrderCustomerControllerPreviewEmailBodyPath = '/order-customer/{id}/preview-body';

  /**
   * Preview del body di una mail di un ordine cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderCustomerControllerPreviewEmailBody()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderCustomerControllerPreviewEmailBody$Response(params: OrderCustomerControllerPreviewEmailBody$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StringItem;
}>> {
    return orderCustomerControllerPreviewEmailBody(this.http, this.rootUrl, params, context);
  }

  /**
   * Preview del body di una mail di un ordine cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderCustomerControllerPreviewEmailBody$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderCustomerControllerPreviewEmailBody(params: OrderCustomerControllerPreviewEmailBody$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: StringItem;
}> {
    return this.orderCustomerControllerPreviewEmailBody$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: StringItem;
}>): BaseResponse & {
'data'?: StringItem;
} => r.body)
    );
  }

  /** Path part for operation `orderCustomerControllerSendEmail()` */
  static readonly OrderCustomerControllerSendEmailPath = '/order-customer/{id}/send-email';

  /**
   * Invia una mail per un ordine cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderCustomerControllerSendEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderCustomerControllerSendEmail$Response(params: OrderCustomerControllerSendEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return orderCustomerControllerSendEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * Invia una mail per un ordine cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderCustomerControllerSendEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderCustomerControllerSendEmail(params: OrderCustomerControllerSendEmail$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.orderCustomerControllerSendEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `orderCustomerControllerGetAll()` */
  static readonly OrderCustomerControllerGetAllPath = '/order-customer';

  /**
   * Restituisce l'elenco degli ordini cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderCustomerControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderCustomerControllerGetAll$Response(params: OrderCustomerControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderCustomerListResponse;
}>> {
    return orderCustomerControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli ordini cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderCustomerControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderCustomerControllerGetAll(params: OrderCustomerControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderCustomerListResponse;
}> {
    return this.orderCustomerControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderCustomerListResponse;
}>): BaseResponse & {
'data'?: OrderCustomerListResponse;
} => r.body)
    );
  }

  /** Path part for operation `orderCustomerControllerCreate()` */
  static readonly OrderCustomerControllerCreatePath = '/order-customer';

  /**
   * Crea un ordine cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderCustomerControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderCustomerControllerCreate$Response(params: OrderCustomerControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderCustomerItem;
}>> {
    return orderCustomerControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un ordine cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderCustomerControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderCustomerControllerCreate(params: OrderCustomerControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderCustomerItem;
}> {
    return this.orderCustomerControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderCustomerItem;
}>): BaseResponse & {
'data'?: OrderCustomerItem;
} => r.body)
    );
  }

  /** Path part for operation `orderCustomerControllerFindOrderCustomerNodes()` */
  static readonly OrderCustomerControllerFindOrderCustomerNodesPath = '/order-customer/nodes/{id}';

  /**
   * Restituisce gli stati successivi dell'ordine cliente disponibili in base a quello attuale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderCustomerControllerFindOrderCustomerNodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderCustomerControllerFindOrderCustomerNodes$Response(params: OrderCustomerControllerFindOrderCustomerNodes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: NextStatesResponse;
}>> {
    return orderCustomerControllerFindOrderCustomerNodes(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce gli stati successivi dell'ordine cliente disponibili in base a quello attuale.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderCustomerControllerFindOrderCustomerNodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderCustomerControllerFindOrderCustomerNodes(params: OrderCustomerControllerFindOrderCustomerNodes$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: NextStatesResponse;
}> {
    return this.orderCustomerControllerFindOrderCustomerNodes$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: NextStatesResponse;
}>): BaseResponse & {
'data'?: NextStatesResponse;
} => r.body)
    );
  }

  /** Path part for operation `orderCustomerControllerBatchChangeCustomerOrderStatus()` */
  static readonly OrderCustomerControllerBatchChangeCustomerOrderStatusPath = '/order-customer/batch/change-status';

  /**
   * Cambio stato massivo ordini cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderCustomerControllerBatchChangeCustomerOrderStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderCustomerControllerBatchChangeCustomerOrderStatus$Response(params: OrderCustomerControllerBatchChangeCustomerOrderStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BatchUpdateResponse;
}>> {
    return orderCustomerControllerBatchChangeCustomerOrderStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Cambio stato massivo ordini cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderCustomerControllerBatchChangeCustomerOrderStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderCustomerControllerBatchChangeCustomerOrderStatus(params: OrderCustomerControllerBatchChangeCustomerOrderStatus$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: BatchUpdateResponse;
}> {
    return this.orderCustomerControllerBatchChangeCustomerOrderStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: BatchUpdateResponse;
}>): BaseResponse & {
'data'?: BatchUpdateResponse;
} => r.body)
    );
  }

  /** Path part for operation `orderCustomerControllerChangeCustomerOrderWorkflowStatus()` */
  static readonly OrderCustomerControllerChangeCustomerOrderWorkflowStatusPath = '/order-customer/change-customer-order-status/{id}';

  /**
   * Modifica lo stato di un ordine cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderCustomerControllerChangeCustomerOrderWorkflowStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderCustomerControllerChangeCustomerOrderWorkflowStatus$Response(params: OrderCustomerControllerChangeCustomerOrderWorkflowStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderCustomerItemEssential;
}>> {
    return orderCustomerControllerChangeCustomerOrderWorkflowStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica lo stato di un ordine cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderCustomerControllerChangeCustomerOrderWorkflowStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderCustomerControllerChangeCustomerOrderWorkflowStatus(params: OrderCustomerControllerChangeCustomerOrderWorkflowStatus$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderCustomerItemEssential;
}> {
    return this.orderCustomerControllerChangeCustomerOrderWorkflowStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderCustomerItemEssential;
}>): BaseResponse & {
'data'?: OrderCustomerItemEssential;
} => r.body)
    );
  }

  /** Path part for operation `orderCustomerControllerGetReplaceProductImpact()` */
  static readonly OrderCustomerControllerGetReplaceProductImpactPath = '/order-customer/{id}/replace-product/impact';

  /**
   * Preview impatto sostituzione prodotto: conta consegne e ticket non definitivi che verranno modificati.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderCustomerControllerGetReplaceProductImpact()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderCustomerControllerGetReplaceProductImpact$Response(params: OrderCustomerControllerGetReplaceProductImpact$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return orderCustomerControllerGetReplaceProductImpact(this.http, this.rootUrl, params, context);
  }

  /**
   * Preview impatto sostituzione prodotto: conta consegne e ticket non definitivi che verranno modificati.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderCustomerControllerGetReplaceProductImpact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderCustomerControllerGetReplaceProductImpact(params: OrderCustomerControllerGetReplaceProductImpact$Params, context?: HttpContext): Observable<void> {
    return this.orderCustomerControllerGetReplaceProductImpact$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `orderCustomerControllerReplaceProduct()` */
  static readonly OrderCustomerControllerReplaceProductPath = '/order-customer/{id}/replace-product';

  /**
   * Sostituisce il prodotto in un ordine cliente, nelle consegne non definitive e negli asset management dei ticket staging/verbale non definitivi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderCustomerControllerReplaceProduct()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderCustomerControllerReplaceProduct$Response(params: OrderCustomerControllerReplaceProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return orderCustomerControllerReplaceProduct(this.http, this.rootUrl, params, context);
  }

  /**
   * Sostituisce il prodotto in un ordine cliente, nelle consegne non definitive e negli asset management dei ticket staging/verbale non definitivi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderCustomerControllerReplaceProduct$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderCustomerControllerReplaceProduct(params: OrderCustomerControllerReplaceProduct$Params, context?: HttpContext): Observable<void> {
    return this.orderCustomerControllerReplaceProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `orderCustomerControllerGetOne()` */
  static readonly OrderCustomerControllerGetOnePath = '/order-customer/{id}';

  /**
   * Restituisce un ordine cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderCustomerControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderCustomerControllerGetOne$Response(params: OrderCustomerControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderCustomerItem;
}>> {
    return orderCustomerControllerGetOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un ordine cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderCustomerControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderCustomerControllerGetOne(params: OrderCustomerControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderCustomerItem;
}> {
    return this.orderCustomerControllerGetOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderCustomerItem;
}>): BaseResponse & {
'data'?: OrderCustomerItem;
} => r.body)
    );
  }

  /** Path part for operation `orderCustomerControllerDeleteOne()` */
  static readonly OrderCustomerControllerDeleteOnePath = '/order-customer/{id}';

  /**
   * Elimina un ordine cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderCustomerControllerDeleteOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderCustomerControllerDeleteOne$Response(params: OrderCustomerControllerDeleteOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderCustomerItem;
}>> {
    return orderCustomerControllerDeleteOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un ordine cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderCustomerControllerDeleteOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  orderCustomerControllerDeleteOne(params: OrderCustomerControllerDeleteOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderCustomerItem;
}> {
    return this.orderCustomerControllerDeleteOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderCustomerItem;
}>): BaseResponse & {
'data'?: OrderCustomerItem;
} => r.body)
    );
  }

  /** Path part for operation `orderCustomerControllerEdit()` */
  static readonly OrderCustomerControllerEditPath = '/order-customer/{id}';

  /**
   * Modifica un ordine cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderCustomerControllerEdit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderCustomerControllerEdit$Response(params: OrderCustomerControllerEdit$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderItemDetail;
}>> {
    return orderCustomerControllerEdit(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un ordine cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderCustomerControllerEdit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderCustomerControllerEdit(params: OrderCustomerControllerEdit$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderItemDetail;
}> {
    return this.orderCustomerControllerEdit$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderItemDetail;
}>): BaseResponse & {
'data'?: OrderItemDetail;
} => r.body)
    );
  }

  /** Path part for operation `customerOrderStatusControllerGetAll()` */
  static readonly CustomerOrderStatusControllerGetAllPath = '/order/customer-status';

  /**
   * Restituisce l'elenco degli stati degli ordini cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerOrderStatusControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerOrderStatusControllerGetAll$Response(params?: CustomerOrderStatusControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusListResponse;
}>> {
    return customerOrderStatusControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli stati degli ordini cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerOrderStatusControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerOrderStatusControllerGetAll(params?: CustomerOrderStatusControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderStatusListResponse;
}> {
    return this.customerOrderStatusControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusListResponse;
}>): BaseResponse & {
'data'?: OrderStatusListResponse;
} => r.body)
    );
  }

  /** Path part for operation `customerOrderStatusControllerCreate()` */
  static readonly CustomerOrderStatusControllerCreatePath = '/order/customer-status';

  /**
   * Crea uno stato per l'ordine cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerOrderStatusControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerOrderStatusControllerCreate$Response(params: CustomerOrderStatusControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>> {
    return customerOrderStatusControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea uno stato per l'ordine cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerOrderStatusControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerOrderStatusControllerCreate(params: CustomerOrderStatusControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderStatusItem;
}> {
    return this.customerOrderStatusControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>): BaseResponse & {
'data'?: OrderStatusItem;
} => r.body)
    );
  }

  /** Path part for operation `customerOrderStatusControllerFindAll()` */
  static readonly CustomerOrderStatusControllerFindAllPath = '/order/customer-status/all';

  /**
   * Restituisce l'elenco degli stati degli ordini cliente con parametri.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerOrderStatusControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerOrderStatusControllerFindAll$Response(params?: CustomerOrderStatusControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusPaginatedResponseItem;
}>> {
    return customerOrderStatusControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli stati degli ordini cliente con parametri.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerOrderStatusControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerOrderStatusControllerFindAll(params?: CustomerOrderStatusControllerFindAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderStatusPaginatedResponseItem;
}> {
    return this.customerOrderStatusControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusPaginatedResponseItem;
}>): BaseResponse & {
'data'?: OrderStatusPaginatedResponseItem;
} => r.body)
    );
  }

  /** Path part for operation `customerOrderStatusControllerFindOne()` */
  static readonly CustomerOrderStatusControllerFindOnePath = '/order/customer-status/{id}';

  /**
   * Restituisce uno stato ordine cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerOrderStatusControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerOrderStatusControllerFindOne$Response(params: CustomerOrderStatusControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>> {
    return customerOrderStatusControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce uno stato ordine cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerOrderStatusControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerOrderStatusControllerFindOne(params: CustomerOrderStatusControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderStatusItem;
}> {
    return this.customerOrderStatusControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>): BaseResponse & {
'data'?: OrderStatusItem;
} => r.body)
    );
  }

  /** Path part for operation `customerOrderStatusControllerUpdate()` */
  static readonly CustomerOrderStatusControllerUpdatePath = '/order/customer-status/{id}';

  /**
   * Aggiorna uno stato ordine cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerOrderStatusControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerOrderStatusControllerUpdate$Response(params: CustomerOrderStatusControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>> {
    return customerOrderStatusControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiorna uno stato ordine cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerOrderStatusControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customerOrderStatusControllerUpdate(params: CustomerOrderStatusControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderStatusItem;
}> {
    return this.customerOrderStatusControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>): BaseResponse & {
'data'?: OrderStatusItem;
} => r.body)
    );
  }

  /** Path part for operation `customerOrderStatusControllerRemove()` */
  static readonly CustomerOrderStatusControllerRemovePath = '/order/customer-status/{id}';

  /**
   * Elimina uno stato ordine cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customerOrderStatusControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerOrderStatusControllerRemove$Response(params: CustomerOrderStatusControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>> {
    return customerOrderStatusControllerRemove(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina uno stato ordine cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customerOrderStatusControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customerOrderStatusControllerRemove(params: CustomerOrderStatusControllerRemove$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OrderStatusItem;
}> {
    return this.customerOrderStatusControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>): BaseResponse & {
'data'?: OrderStatusItem;
} => r.body)
    );
  }

}
